<template>
  <div class="pa-4 mt-8">
    <p class="primary--text display-1 font-weight-bold pb-4">
      Algunas especies registradas
    </p>
    <v-row>
      <v-col cols="12" md="4" v-for="item of list" :key="item.id">
        <LibraryCard :item="item"></LibraryCard>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import LibraryCard from "../Library/LibraryCard";
export default {
  components: { LibraryCard },
  data: () => ({
    list: []
  }),
  async mounted() {
    try {
      let { data: list } = await this.$http.get("organism", {
        params: {
          where: {
            sp_card: true
          },
          sort: "updatedAt DESC",
          limit: 3
        }
      });
      this.list = list;
    } catch (err) {}
  }
};
</script>

<style></style>
